import { defineComponent as _defineComponent } from 'vue'
interface Props {
  datetime: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InDmDate',
  props: {
    datetime: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})